"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlaresasAppallingSquallAbilityHandler = exports.AlaresasAppallingSquallActorAbilityFactory = exports.AlaresasAppallingSquallAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class AlaresasAppallingSquallAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.AlaresasAppallingSquall;
        this.__typeName = "AlaresasAppallingSquall";
    }
}
exports.AlaresasAppallingSquallAbilityArgs = AlaresasAppallingSquallAbilityArgs;
let AlaresasAppallingSquallActorAbilityFactory = class AlaresasAppallingSquallActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("AlaresasAppallingSquall", "OneEnemies", 2);
    }
};
AlaresasAppallingSquallActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("AlaresasAppallingSquall")
], AlaresasAppallingSquallActorAbilityFactory);
exports.AlaresasAppallingSquallActorAbilityFactory = AlaresasAppallingSquallActorAbilityFactory;
let AlaresasAppallingSquallAbilityHandler = class AlaresasAppallingSquallAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Sonic", 70)
            ],
            onHit: sequence => {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(1),
                    effect: new core_1.StunEffectArgs(),
                    onAppliedOrResisted: (sequence, _, applied) => sequence.push(new core_2.InstantVfxStepArgs(applied ? new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "chest", "front")
                        : LocationSelector_1.ActorVfxLocationSelector.Miss(selectedEnemy), 
                    // TODO: replace with a better instant vfx
                    "BloodyClaws")),
                });
            }
        });
    }
};
AlaresasAppallingSquallAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.AlaresasAppallingSquall)
], AlaresasAppallingSquallAbilityHandler);
exports.AlaresasAppallingSquallAbilityHandler = AlaresasAppallingSquallAbilityHandler;
